var idID = {
  locale: 'id_ID',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    shortMonthList: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
    monthList: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
    shortDayList: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
    dayList: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
    shortestDayList: ['Mg', 'Sn', 'Sl', 'Rb', 'Km', 'Jm', 'Sb']
  },
  'dynamic-date': {
    day: 'Hari',
    week: 'Minggu',
    month: 'Bulan',
    quarter: 'Triwulan',
    year: 'Tahun',
    before: 'Sebelum ${value}${unit}'
  },
  'auto-complete.empty': 'Tidak ada data',
  'select.selected-count': '${count} item yang dipilih',
  'date-time-picker.date': 'Pilih tanggal',
  'image-view.zoom-out': 'Perkecil',
  'input.placeholder': 'Masukkan',
  'empty.text': 'Tidak ada data',
  'date-picker.cancel': 'Batal',
  'date-picker.end': 'Waktu selesai',
  'cascader.empty': 'Tidak ada data',
  'upload.drop': 'Seret file ke sini atau',
  'color.custom': 'Sesuaikan warna',
  'cascader.titles': ['Level 1', 'Level 2', 'Level 3', 'Level 4', 'Level 5', 'Level 6', 'Level 7', 'Level 8'],
  'date-comparison.error-target': 'Pilih waktu selesai untuk perbandingan',
  'transfer.empty': 'Tidak ada data',
  'select.search.placeholder': 'Masukkan',
  'upload.click': 'Klik untuk mengunggah',
  'date-time-picker.placeholder': 'Masukkan',
  'pager.jump': 'Alihkan',
  'tree-select.placeholder': 'Masukkan',
  'dynamic-date.interval': 'Interval',
  'modal.cancel': 'Batal',
  'image-view.rotate': 'Putar',
  'tabs.more': 'Lainnya',
  'popover.ok': 'Konfirmasi',
  'transfer.placeholder': 'Masukkan',
  'date.month': 'Bulan',
  'select.selected': 'Terpilih',
  'popover.cancel': 'Batal',
  'image-view.prev': 'Sebelumnya',
  'table.emptyText': 'Tidak ada data',
  'date-time-picker.ok': 'Konfirmasi',
  'table.filter.confirm': 'Konfirmasi',
  'tree-select.empty': 'Tidak ada data',
  'dynamic-date.fixed-date': 'Tanggal tetap',
  'date-comparison.compare': 'Bandingkan',
  'auto-complete.placeholder': 'Masukkan',
  'time-picker.placeholder': 'Pilih waktu',
  'date.month-first': false,
  'select.clear': 'Bersihkan',
  'date.year': 'Tahun ${year}',
  'date-comparison.yoy': 'Jangka waktu ini pada tahun lalu',
  'image-view.zoom-to-origin': 'Asal',
  'schedule.title': 'Tanggal/Waktu',
  'schedule.clear': 'Bersihkan',
  'date-time-picker.end': 'Pilih tanggal dan waktu selesai',
  'dynamic-date.customize': 'Sesuaikan',
  'date-picker.apply': 'Terapkan',
  'schedule.selected': 'Waktu yang dipilih',
  'dynamic-date.dynamic-date': 'Tanggal dinamis',
  'select.placeholder': 'Pilih',
  'schedule.separator': ',',
  'cascader.search': 'Masukkan',
  'date-picker.invalid-range': 'Rentang waktu yang dipilih melampaui rentang yang dapat dipilih. Pilih rentang waktu yang valid.',
  'dynamic-date.date-preview': 'Pratinjau tanggal',
  'select.empty': 'Tidak ada data',
  'image-view.next': 'Berikutnya',
  'date-time-picker.now': 'Sekarang',
  'date-time-picker.time': 'Pilih waktu',
  'tree.empty': 'Tidak ada data',
  'pager.total': 'Total ${total} catatan',
  'image-view.zoom-in': 'Perbesar',
  'date-picker.placeholder': 'Pilih tanggal',
  'textarea.placeholder': 'Masukkan',
  'date.week': 'Minggu',
  'pager.size': '${count} catatan/halaman',
  'modal.ok': 'Konfirmasi',
  'date-picker.start': 'Waktu mulai',
  'table.filter.reset': 'Reset',
  'image-view.zoom-to-fit': 'Paskan',
  'pager.page.placeholder': 'Masukkan',
  'select.select-all': 'Pilih semua',
  'list-viewer.empty': 'Tidak ada data',
  'date-comparison.compare-text': 'VS',
  'transfer.source': 'Daftar sumber',
  'date-time-picker.start': 'Pilih tanggal dan waktu mulai',
  'date-time-picker-panel.start': 'Mulai tanggal',
  'date-time-picker-panel.end': 'Tanggal akhir',
  'date-comparison.error-source': 'Pilih waktu mulai untuk perbandingan',
  'upload.error.overflow-count': 'Melebihi jumlah maksimum file',
  'date-comparison.placeholder': 'Waktu mulai - Waktu selesai',
  'time-range-picker.placeholder': 'Waktu mulai - Waktu selesai',
  'date-comparison.mom': 'Dibandingkan dengan jangka waktu sebelumnya',
  'transfer.target': 'Daftar target',
  table: {
    selectionMenu: {
      selectCurrent: 'Select Current',
      selectAll: 'Select All',
      unselectCurrent: 'Unselect Current',
      unselectAll: 'Unselect All'
    }
  }
};
export default idID;